import React, { useEffect, useState } from 'react'
import { alpha, makeStyles } from '@material-ui/core/styles'
import {
  AppBar,
  Avatar,
  Badge,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from '@material-ui/core'
import trovityLogo from 'src/assets/Header_Images/trovityLogo.svg'
import notificationImg from 'src/assets/Header_Images/Vector1.svg'
import helpImg from 'src/assets/Header_Images/Vector2.svg'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { useKeycloak } from '@react-keycloak/web'
import { useSelector } from 'react-redux'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import { Link, useHistory } from 'react-router-dom'
import { COLORS } from 'src/utils/Themes/colors'
import { getLogo } from 'src/services/individualService'
import FullScreenButton from 'src/FullScreenButton'
import { ROLES } from 'src/utils/constants/common'

const Header = () => {
  const classes = useStyles()
  const history = useHistory()
  const userInfo = useSelector((state) => state?.userInfo)
  const clientId = userInfo?.userInfo?.userData?.clientId
  const { keycloak } = useKeycloak()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null)
  const isMenuOpen = Boolean(anchorEl)
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)

  const [companyLogoDetails, setCompanyLogoDetails] = useState({
    present: false,
    logoAddress: null,
  })

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
    handleMobileMenuClose()
  }

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event?.currentTarget)
  }

  const getClientLogo = async () => {
    const response = await getLogo(clientId)
    setCompanyLogoDetails({
      present: response?.res?.data?.present,
      logoAddress: response?.res?.data?.logoAddress,
    })
  }

  const menuId = 'primary-search-account-menu'
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  )

  const mobileMenuId = 'primary-search-account-menu-mobile'
  const userLogOut = () => {
    history.push('/individual/dashboard')
    sessionStorage.clear()
    keycloak.logout()
  }
  const renderMobileMenu = (
    <Menu
      id='fade-menu'
      MenuListProps={{
        'aria-labelledby': 'fade-button',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Link
        className={classes.navigationStyle}
        to={'/individual/dashboard/profile'}
      >
        <MenuItem onClick={handleMobileMenuClose}>My Profile</MenuItem>
      </Link>
      <Divider />
      <MenuItem onClick={userLogOut}>
        <ExitToAppIcon className={classes.exitIcon} />
        Logout
      </MenuItem>
    </Menu>
  )

  useEffect(() => {
    getClientLogo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId])

  return (
    <div className={classes.grow}>
      <AppBar className={classes.appBackgroundColor} position='static'>
        <Toolbar className={classes.toolbar}>
          <Link
            className={classes.trovityLogoNavigation}
            to={'/individual/dashboard/'}
          >
            <img
              className={classes.TrovityLogo}
              src={trovityLogo}
              alt={'TrovityLogo'}
            />
          </Link>
          {userInfo?.userInfo?.userData?.policyHolderType !==
          ROLES?.RETAIL_INDIVIDUAL ? (
            <div className={classes.logoContainer}>
              {companyLogoDetails?.present ? (
                <img
                  className={classes.companyLogo}
                  src={companyLogoDetails?.logoAddress}
                  alt={'Company Logo'}
                />
              ) : (
                <p className={classes.logoCompanyText}>{clientId}</p>
              )}
              <p className={classes.insuranceText}>
                {clientId} Insurance portal
              </p>
            </div>
          ) : null}
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <IconButton
              className={classes.helpIconBtn}
              aria-label='show 4 new mails'
              color='inherit'
            >
              <Badge color='secondary'>
                <img
                  src={helpImg}
                  className={classes.helpIcon}
                  alt={'helpIcon'}
                />
              </Badge>
            </IconButton>
            <IconButton
              className={classes.notificationIconBtn}
              aria-label='show 17 new notifications'
              color='inherit'
            >
              <Badge color='secondary'>
                <img
                  src={notificationImg}
                  className={classes.notificationIcon}
                  alt={'notificationIcon'}
                />
              </Badge>
            </IconButton>
          </div>
          <FullScreenButton />
          <Divider orientation='vertical' flexItem />
          <div className={classes.avatarContainer}>
            <div>
              <Avatar alt='Remy Sharp' className={classes.proPic} />
            </div>
            <div>
              <Typography className={classes.userText}>Welcome back</Typography>
              <div className={classes.usernameContainer}>
                <strong className={classes.userNameText}>
                  {userInfo?.userName}
                </strong>
                <IconButton
                  aria-label='show more'
                  aria-controls={mobileMenuId}
                  aria-haspopup='true'
                  onClick={handleMobileMenuOpen}
                  color='inherit'
                  className={classes.arrowDropDownIconBtn}
                >
                  <ArrowDropDownIcon className={classes.dropDownArrow} />
                </IconButton>
              </div>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </div>
  )
}

export default Header

const useStyles = makeStyles((theme) => ({
  appBackgroundColor: {
    backgroundColor: COLORS.WHITE,
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '2px 0px 0px -38px',
    position: 'absolute',
    left: '45%',
    alignItems: 'center',
  },
  insuranceText: {
    color: COLORS.MEDIUM_BLUE,
    fontSize: '7.5px',
    opacity: '0.4',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    margin: '0px',
    marginTop: '2px',
  },
  toolbar: {
    minHeight: '60px',
    height: '1vh',
    paddingLeft: '15px',
    paddingRight: '0px',
    boxShadow: '0px 0px 10px 0px #00000033',
  },
  TrovityLogo: {
    width: '110px',
    padding: '5px 0',
  },
  companyLogo: {
    width: '90px',
    height: '30px',
  },
  dropDownArrow: {
    fill: 'inherit',
    fontSize: '1rem',
    paddingTop: '10px',
  },
  userText: {
    color: COLORS.MEDIUM_BLUE02,
    fontSize: '10px',
  },
  userNameText: {
    color: COLORS.MEDIUM_BLUE04,
    fontSize: '12px',
    marginTop: '-12px',
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  sectionImage: {
    width: '70%',
    height: '70%',
  },
  proPic: {
    margin: '0px 5px 0px 15px',

    width: '30px ',
    height: '30px',
  },
  helpIcon: {
    width: '18px',
  },
  notificationIcon: {
    width: '15px',
  },
  logoCompanyText: {
    color: COLORS.MEDIUM_BLUE,
    fontSize: '12px',
    textTransform: 'uppercase',
    textAlign: 'center',
    letterSpacing: '1px',
    margin: '0px',
    marginTop: '2px',
  },
  navigationStyle: {
    textDecoration: 'None',
    color: COLORS?.MEDIUM_BLUE,
    padding: '5px',
  },
  exitIcon: {
    padding: '5px',
  },
  trovityLogoNavigation: {
    textDecoration: 'None',
    color: COLORS?.MEDIUM_BLUE,
  },
  helpIconBtn: {
    width: '40px',
    height: '50px',
    borderRadius: '0px',
  },
  avatarContainer: {
    paddingTop: '10px',
    display: 'flex',
  },
  usernameContainer: {
    marginTop: '-15px',
  },
  notificationIconBtn: {
    width: '40px',
    height: '50px',
    borderRadius: '0px',
    marginRight: '5px',
  },
  arrowDropDownIconBtn: {
    marginTop: '-10px',
    marginLeft: '-10px',
  },
}))
